export default __webpack_public_path__ + "static/media/Info_Distribución_CON_recaudo_Envío_Contra_Entrega.c2a4af84.png";